module.exports = __webpack_public_path__ + "static/media/logo.6c6e44b8.png";